import { TranslatePipe } from '@ngx-translate/core';

import { input, computed, Component, ChangeDetectionStrategy } from '@angular/core';

import { Tag } from '@shared/ui/tag';

import { type TagMeta } from '@shared/types';

import { type User } from '../../models';

type UserStatusSource = Pick<User, 'active' | 'verified'>;

function getUserStatusMeta(user: UserStatusSource): TagMeta {
  if (!user.active) {
    return { labelKey: 'entities.user.status.deactivated', color: 'neutral' };
  }
  if (!user.verified) {
    return { labelKey: 'entities.user.status.invited', color: 'info' };
  }
  return { labelKey: 'entities.user.status.active', color: 'success' };
}

@Component({
  selector: 'app-user-status-tag',
  imports: [Tag, TranslatePipe],
  templateUrl: './user-status-tag.html',
  styleUrl: './user-status-tag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserStatusTag {
  public readonly user = input.required<UserStatusSource>();

  private readonly statusMeta = computed(() => getUserStatusMeta(this.user()));

  protected readonly color = computed(() => this.statusMeta().color);
  protected readonly labelKey = computed(() => this.statusMeta().labelKey);
}
